import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-195a0969"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-notification" }
const _hoisted_2 = ["onClick"]

import { computed, watch, ref, warn } from 'vue'
import { useI18n } from 'vue-i18n'

import gsap from 'gsap'
import frames from '@/utils/FrameToTime'

import { useGameState } from '@/services/composition';
import { Hotspot, useHotspots } from '@/services/stores/hotspots';
import { HotspotId } from '@/services/states/GameContextDatas';

import UIGameNotificationItem from './UIGameNotificationItem.vue';
import AudioManager, { AUDIO_ID } from '@/core/audio/AudioManager';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const state = useGameState()
const { findHotspot } = useHotspots()

const progress = ref(0)
const NOTIFICATION_TIMEOUT = 5000
const notifications = ref<{ id: number, icon?: string, title?: string, description?: string, points?: number }[]>([])

// const eventType = computed(() => {
//   return state.value.event.type
// })

// watch(eventType, (eventType) => {
//   if (eventType === 'GAME_HOTSPOT_ACTION_DONE') {
//     const id = state.value.event.payload as HotspotId
//     const hotspot = findHotspot(id)

//     if (hotspot.points > 0 || hotspot.points < 0) {
//       addNotification(hotspot)
//     }
//   }
// })

const lastDoneHotspot = computed(() => {
  return state.value.context.hotspots.length && state.value.context.hotspots[state.value.context.hotspots.length - 1]
})

const currentNotification = computed(() => {
  return notifications.value[notifications.value.length - 1]
})

watch(lastDoneHotspot, (id) => {
  const hotspot = findHotspot(id)

  if (hotspot.points > 0 || hotspot.points < 0) {
    addNotification(hotspot)
  }
})

const addNotification = (hotspot: Hotspot) => {
  const icon = hotspot.points > 0 ? 'checkmark' : 'crossmark'
  const title = hotspot.points > 0 ? t(`hotspots.action_good`) : t(`hotspots.action_bad`)
  const description = t(`hotspots.${hotspot.name}.description`)
  
  notifications.value.push({ id: hotspot.id, icon, title, description, points: hotspot.points })
}

const remove = async () => {
  progressTL.value?.kill()
  progressTL.value = await gsap.to(progress, { value: 1, duration: frames(10), ease: 'quint.out' })
  notifications.value = []
}

const onEnter = (el: HTMLElement, onComplete: gsap.Callback) => {
  AudioManager.play(AUDIO_ID.UI_POP_IN)
  // progressTL.value?.kill()

  const $ = gsap.utils.selector(el)
  const tl = gsap.timeline({ onComplete })
  tl.fromTo(el, { yPercent: 100, }, {yPercent: 0, duration: frames(30), ease: 'quint.out' })
  tl.fromTo($('[data-transition-enter]'), { yPercent: 100, opacity: 0, }, {yPercent: 0, opacity: 1, duration: frames(30), ease: 'quint.out', stagger: 0.1 }, 0.2)
}

const progressTL = ref(null)
const onAfterEnter = () => {
  progressTL.value?.kill()
  progressTL.value = gsap.fromTo(
    progress,
    {
      value: 0
    },
    {
      value: 1,
      duration: NOTIFICATION_TIMEOUT / 1000,
      onComplete: () => {
        remove()
        // notifications.value = []
      }
    }
  )
}

const onLeave = (el: HTMLElement, onComplete: gsap.Callback) => {
  const tl = gsap.timeline({ onComplete })

  progressTL.value?.kill()

  tl.to(el, { yPercent: 100, duration: frames(30), ease: 'quint.in' })
  tl.to(progress, { value: 0, duration: frames(30) }, 0)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      css: false,
      mode: "out-in",
      onEnter: onEnter,
      onAfterEnter: onAfterEnter,
      onLeave: onLeave
    }, {
      default: _withCtx(() => [
        (_unref(currentNotification))
          ? (_openBlock(), _createBlock(UIGameNotificationItem, _mergeProps({
              key: 0,
              key: _unref(currentNotification).id
            }, _unref(currentNotification)), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(currentNotification))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _withModifiers(remove, ["prevent","stop"]),
          class: "backdrop"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(currentNotification))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "progress-bar",
              style: _normalizeStyle(`--progress: ${progress.value}`)
            }, null, 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})